import { tv } from 'tailwind-variants'

export const headerChatVariants = tv({
  slots: {
    base: 'rounded-t-mili',
    container: 'px-deca py-micro flex items-center justify-between',
    clientName: 'flex flex-row items-center space-x-micro text-h5 text-base font-bold',
    phoneNumber: 'flex flex-row items-center space-x-micro text-sub text-secondary-medium',
    options: 'flex px-deca gap-x-deca',
    pipOption: 'text-primary-medium text-deca',
    tagsTop: 'flex space-x-mili items-center',
    tagsBottom: 'flex space-x-mili items-center ml-deca mb-mili',
    row: 'flex space-x-deca',
    header: 'flex flex-col'
  }
})
